export const contactValidationMessages = {
  nameRequired: "נא להזין שם מלא",
  nameInvalid: "נא להזין שם מלא, למשל דנה לוי",
  phoneRequired: "נא להזין מספר טלפון",
  phoneInvalid: "מספר הטלפון אינו תקין. לדוגמה: 050-1234567"
};

function normalizePhone(value) {
  const raw = value.trim();
  if (raw.length > 40 || !/^\+?[0-9 ().-]+$/.test(raw)) return undefined;
  let digits = raw.replace(/[ ().-]/g, "");
  if (digits.startsWith("+972")) {
    digits = digits.slice(4).replace(/^0/, "");
    if (!digits.startsWith("1")) digits = "0" + digits;
  }
  if (/^0[0-9]{8,9}$/.test(digits)) return "+972" + digits.slice(1);
  if (/^1[78]00[0-9]{6}$/.test(digits)) return "+972" + digits;
  // International format only; this form does not verify ownership or allocated prefixes.
  if (!digits.startsWith("+972") && /^\+[1-9][0-9]{7,14}$/.test(digits)) return digits;
  return undefined;
}

export function formatContactPhone(value) {
  const phone = normalizePhone(value);
  if (!phone || !phone.startsWith("+972")) return value;
  const national = phone.slice(4);
  if (national.startsWith("1")) return national;
  const local = "0" + national;
  return local.slice(0, -7) + "-" + local.slice(-7);
}

export function validateContact(name, phone) {
  const errors = {};
  const normalizedName = name.trim().replace(/\s+/gu, " ");
  if (/[\p{Cc}<>]/u.test(name) || [...normalizedName].length < 1 || [...normalizedName].length > 100 || !/\p{L}/u.test(normalizedName)) {
    errors.contactName = normalizedName ? contactValidationMessages.nameInvalid : contactValidationMessages.nameRequired;
  }
  const normalizedPhone = normalizePhone(phone);
  if (!normalizedPhone) {
    errors.contactPhone = phone.trim() ? contactValidationMessages.phoneInvalid : contactValidationMessages.phoneRequired;
  }
  return { errors, phone: normalizedPhone };
}
